// ==============================================
// ==================Import======================
// ==============================================

// ==================Dependancies=================
import PropTypes from 'prop-types';

// ==================React=================
import { Link } from 'react-router-dom';

export default function linkMarker(props) {
  return <Link to={`/metadata/marker=${props.value}/description`} target="_blank">{props.value}</Link>;
}

linkMarker.propTypes = {
  props: PropTypes.objectOf(),
};
